const SITE = "https://www.mag-automate.com";
const DEFAULT_IMAGE = `${SITE}/mag-logo-hd.png`;

export default function Seo({
  title,
  description,
  path,
  noindex = false,
  robots,
  image = DEFAULT_IMAGE,
  jsonLd,
}) {
  const url = path === "/" ? `${SITE}/` : `${SITE}${path}`;
  const robotsContent = robots ?? (noindex ? "noindex" : null);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {!noindex && <link rel="canonical" href={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {robotsContent && <meta name="robots" content={robotsContent} />}
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
}
